import { SxProps } from '@mui/material';

export const pageCardFooterStyles: SxProps = {};
